//Los reducers controlan las acciones.
//Los reducers son funciones que sirven para realizar acciones.
//El reducer tiene la información y se encarga de mandarla a la store.

const initialState = {
    authenticated: false,
}

const LoginReducer = (state = initialState.authenticated, action) =>{
    switch(action.type){
        case 'isAuthenticated': return true;
        case 'notAuthenticated': return false;
        default: return state;
    }
}

export default  LoginReducer;

